import PickupCarrierManager from "./PickupCarrierManager";
import { displayPickupError } from "./pickupErrorHandler";
import CarrierSelectionHandler from "./CarrierSelectionHandler";
import { GelProximityBtn } from "./elementUtils";
import "@/styles/gelProximity.css";

const gelproximityScriptURL = "https://platform.gelproximity.com/sdk/latest.js";

document.addEventListener("DOMContentLoaded", () => {
  const error = window.pickupCarrierError;

  if (error) {
    displayPickupError(error);
  } else {
    try {
      const script = document.createElement("script");
      const gelConfig = window.gelProximityConfig;

      script.src = gelproximityScriptURL;
      script.onload = () => {
        const gelSDK = new GelSDK({
          urlEndUser: gelConfig.urlEndUser,
          merchantCode: gelConfig.merchantCode,
          apiKey: gelConfig.apiKey,
          reference: gelConfig.reference,
          redirectMode: "POST",
          locale: gelConfig.locale,
        });

        const pickupCarrierManager = new PickupCarrierManager(gelSDK);
        const carrierSelectionHandler = new CarrierSelectionHandler(
          pickupCarrierManager,
        );

        pickupCarrierManager.setCarrierSelectionHandler(
          carrierSelectionHandler,
        );

        carrierSelectionHandler.handleCarrierSelection(gelConfig);
        const btn = document.getElementById(GelProximityBtn);

        if (btn) {
          pickupCarrierManager.addPickupCarrierListener(btn);
        }
      };
      document.head.appendChild(script);
    } catch (error) {
      displayPickupError();
      console.error(error);
    }
  }
});
